'use es6';

/**
 * Temporary vendored file for react-dnd-accessible-backend@1.0.1
 * - source: https://unpkg.com/react-dnd-accessible-backend@1.0.1
 * - docs: https://git.hubteam.com/HubSpot/bender-repackages#alternatives-to-repackaging
 */

/* eslint-disable */
!function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module ? t(exports) : 'function' == typeof define && define.amd ? define(['exports'], t) : t((e || self).reactDndAccessibleBackend = {});
}(this, function (e) {
  function t(e) {
    var t, n;
    if (null != e) return null != (t = null != (n = e.getAttribute('data-dnd-name')) ? n : e.getAttribute('aria-label')) ? t : e.innerText;
  }
  var n = {
    pickedUpItem: function (e, n) {
      var i;
      return 'Picked up ' + (null != (i = t(n)) ? i : e);
    },
    droppedItem: function (e, n) {
      var i;
      return 'Dropped ' + (null != (i = t(n)) ? i : e);
    },
    hoveredTarget: function (e, n) {
      var i;
      return 'Over ' + (null != (i = t(n)) ? i : e);
    },
    canceledDrag: function (e, n) {
      var i;
      return 'Stopped dragging ' + (null != (i = t(n)) ? i : e);
    }
  };
  function i() {
    return n;
  }
  var r,
    o = function () {
      function e(e, t) {
        var n,
          r = void 0 === t ? {} : t,
          o = r.getAnnouncementMessages,
          s = r.announcerClassName;
        this.document = void 0, this.target = void 0, this.getMessages = void 0, this.document = e, this.getMessages = null != o ? o : i, this.target = null == (n = this.document) ? void 0 : n.createElement('span'), null != this.target && (this.target.setAttribute('aria-live', 'assertive'), this.target.setAttribute('aria-atomic', 'true'), s ? this.target.className = s : (this.target.className = 'drag-announcer', this.target.style.cssText = 'position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0,0,0,0); border: 0;'));
      }
      var t = e.prototype;
      return t.attach = function () {
        var e;
        null != this.target && (null == (e = this.document) || e.body.appendChild(this.target));
      }, t.detach = function () {
        var e,
          t = null == (e = this.document) ? void 0 : e.body;
        null != this.target && null != t && t.contains(this.target) && t.removeChild(this.target);
      }, t.announce = function (e) {
        null != this.target && (this.target.innerText = e);
      }, t.announceDrag = function (e, t) {
        null != e && this.announce(this.getMessages().pickedUpItem(t, e));
      }, t.announceHover = function (e, t) {
        null != e && this.announce(this.getMessages().hoveredTarget(t, e));
      }, t.announceDrop = function (e, t) {
        this.announce(this.getMessages().droppedItem(t, e));
      }, t.announceCancel = function (e, t) {
        this.announce(this.getMessages().canceledDrag(t, e));
      }, t.clear = function () {
        this.announce('');
      }, e;
    }(),
    s = function () {
      function e(e, t) {
        var n,
          i,
          r,
          o = (void 0 === t ? {} : t).previewerClassName;
        this.document = void 0, this.container = void 0, this.svg = void 0, this.foreignObject = void 0, this.document = e, this.container = null == (n = this.document) ? void 0 : n.createElement('div'), this.svg = null == (i = this.document) ? void 0 : i.createElement('svg'), this.foreignObject = null == (r = this.document) ? void 0 : r.createElement('foreignObject'), null != this.container && null != this.svg && null != this.foreignObject && (o ? this.container.className = o : (this.container.className = 'drag-previewer', this.container.style.cssText = 'z-index: 1000;'), this.svg.appendChild(this.foreignObject), this.container.appendChild(this.svg));
      }
      var t = e.prototype;
      return t.attach = function () {
        var e;
        null != this.container && (null == (e = this.document) || e.body.appendChild(this.container));
      }, t.detach = function () {
        var e,
          t = null == (e = this.document) ? void 0 : e.body;
        null != this.container && null != t && t.contains(this.container) && t.removeChild(this.container);
      }, t.createDragPreview = function (e) {
        if (null != this.container && null != this.svg && null != this.foreignObject) {
          var t = e.getBoundingClientRect(),
            n = t.width,
            i = t.height;
          this.svg.setAttribute('viewBox', '0 0 ' + n + ' ' + i), this.svg.setAttribute('width', '' + n), this.svg.setAttribute('height', '' + i), this.foreignObject.setAttribute('x', '0'), this.foreignObject.setAttribute('y', '0'), this.foreignObject.setAttribute('width', '' + n), this.foreignObject.setAttribute('height', '' + i);
          var r = e.cloneNode(!0);
          this.foreignObject.appendChild(r);
        }
      }, t.render = function (e) {
        var t = this.container;
        if (null != t) {
          var n = e.getSourceClientOffset();
          null != n && e.isDragging() && (t.style.position = 'fixed', t.style.left = n.x + 30 + 'px', t.style.top = n.y + 15 + 'px');
        }
      }, t.clear = function () {
        null != this.foreignObject && (this.foreignObject.innerHTML = '');
      }, e;
    }();
  function a(e) {
    if (null == e) return {
      x: 0,
      y: 0
    };
    var t = e.nodeType === Node.ELEMENT_NODE ? e : e.parentElement;
    if (!t) return {
      x: 0,
      y: 0
    };
    var n = t.getBoundingClientRect();
    return {
      x: n.left,
      y: n.top
    };
  }
  function u(e) {
    e.preventDefault(), e.stopImmediatePropagation();
  }
  !function (e) {
    e.UP = 'ArrowUp', e.DOWN = 'ArrowDown', e.DROP = 'Shift', e.CANCEL = 'Escape';
  }(r || (r = {}));
  var c = function () {
    function e(e, t, n, i, o) {
      var s,
        a = this;
      this.targetNodes = void 0, this.manager = void 0, this.previewer = void 0, this.announcer = void 0, this.currentHoveredNode = void 0, this.focusManager = void 0, this.actions = void 0, this.monitor = void 0, this.handleDraggedElementKeyDown = function (e) {
        switch (e.key) {
          case r.UP:
            return u(e), void a.hoverNode(a.getPreviousDropTarget());
          case r.DOWN:
            return u(e), void a.hoverNode(a.getNextDropTarget());
        }
      }, this.targetNodes = t, this.manager = n, this.previewer = i, this.announcer = o, this.currentHoveredNode = e, this.focusManager = (s = function () {
        return a.getViableTargets(t);
      }, {
        getNextFocusableElement: function (e) {
          var t = (null == e ? void 0 : e.from) || document.activeElement;
          if (null == t) return null;
          var n,
            i = s(),
            r = i.find(function (e) {
              return !!(t.compareDocumentPosition(e) & (Node.DOCUMENT_POSITION_FOLLOWING | Node.DOCUMENT_POSITION_CONTAINED_BY));
            });
          return null == r && null != e && e.wrap ? null != (n = i[0]) ? n : null : r;
        },
        getPreviousFocusableElement: function (e) {
          var t = (null == e ? void 0 : e.from) || document.activeElement;
          if (null == t) return null;
          for (var n, i = s(), r = i.length - 1; r >= 0; r--) {
            var o = i[r];
            if (t.compareDocumentPosition(o) & (Node.DOCUMENT_POSITION_PRECEDING | Node.DOCUMENT_POSITION_CONTAINED_BY)) return o;
          }
          return null != e && e.wrap && null != (n = i[i.length - 1]) ? n : null;
        },
        getFirstFocusableElement: function () {
          var e;
          return null != (e = s()[0]) ? e : null;
        },
        getLastFocusableElement: function () {
          var e,
            t = s();
          return null != (e = t[t.length - 1]) ? e : null;
        }
      }), this.actions = n.getActions(), this.monitor = n.getMonitor(), window.addEventListener('keydown', this.handleDraggedElementKeyDown, {
        capture: !0
      });
    }
    var t = e.prototype;
    return t.disconnect = function () {
      window.removeEventListener('keydown', this.handleDraggedElementKeyDown, {
        capture: !0
      });
    }, t.hoverNode = function (e) {
      var t,
        n = null == (t = Array.from(this.targetNodes.entries()).find(function (t) {
          return e === t[1];
        })) ? void 0 : t[0];
      null != n && (this.actions.hover([n], {
        clientOffset: a(e)
      }), this.currentHoveredNode = e, this.previewer.render(this.monitor), this.announcer.announceHover(e, n), null == e || e.focus());
    }, t.getNextDropTarget = function () {
      var e;
      return this.focusManager.getNextFocusableElement({
        wrap: !1,
        from: null != (e = this.currentHoveredNode) ? e : void 0
      });
    }, t.getPreviousDropTarget = function () {
      var e;
      return this.focusManager.getPreviousFocusableElement({
        wrap: !1,
        from: null != (e = this.currentHoveredNode) ? e : void 0
      });
    }, t.getViableTargets = function (e) {
      return this.getAllowedTargets(e).sort(function (e, t) {
        if (e === t) return 0;
        var n = e.compareDocumentPosition(t);
        return n & (Node.DOCUMENT_POSITION_FOLLOWING | n & Node.DOCUMENT_POSITION_CONTAINED_BY) ? -1 : n & (Node.DOCUMENT_POSITION_PRECEDING | n & Node.DOCUMENT_POSITION_CONTAINS) ? 1 : 0;
      });
    }, t.getAllowedTargets = function (e) {
      var t = this;
      return null == this.monitor.getItemType() ? Array.from(e.values()) : Array.from(e).reduce(function (e, n) {
        var i = n[0],
          r = n[1];
        return t.manager.getMonitor().canDropOnTarget(i) && e.push(r), e;
      }, []);
    }, e;
  }();
  function d(e, t) {
    var n;
    return void 0 === t && (t = !1), !(!t || !1 !== e.isTrusted) || 'd' === (null == (n = e.key) ? void 0 : n.toLowerCase()) && (e.metaKey || e.ctrlKey) && !e.altKey;
  }
  var l = [' ', 'Enter'],
    h = ['Escape'];
  function g(e, t) {
    return t.includes(e.key);
  }
  var v = function () {
    function e(e, t, n) {
      var i,
        r = this;
      this.manager = void 0, this.actions = void 0, this.monitor = void 0, this.context = void 0, this.options = void 0, this.sourceNodes = void 0, this.sourcePreviewNodes = void 0, this.sourcePreviewNodeOptions = void 0, this.targetNodes = void 0, this._navigator = void 0, this._previewer = void 0, this._announcer = void 0, this._isDragTrigger = void 0, this._handlingFirstEvent = !1, this.handleGlobalKeyDown = function (e) {
        if (r.monitor.isDragging() && g(e, h)) {
          r.endDrag(e);
          var t = String(r.monitor.getSourceId()),
            n = r.sourceNodes.get(t);
          r._announcer.announceCancel(null != n ? n : null, t);
        }
      }, this.getSourceClientOffset = function (e) {
        return a(r.sourceNodes.get(e));
      }, this.handleDragStart = function (e, t) {
        var n;
        if (r._isDragTrigger(t, r._handlingFirstEvent) && (r._handlingFirstEvent = !1, r.monitor.canDragSource(e))) if (r.monitor.isDragging()) r.actions.publishDragSource();else {
          u(t);
          var i = r.sourceNodes.get(e);
          null != i && (r._navigator = new c(i, r.targetNodes, r.manager, r._previewer, r._announcer), r._previewer.createDragPreview(null != (n = r.sourcePreviewNodes.get(e)) ? n : i), r.actions.beginDrag([e], {
            clientOffset: r.getSourceClientOffset(e),
            getSourceClientOffset: r.getSourceClientOffset,
            publishSource: !1
          }), r._previewer.render(r.monitor), r.setDndMode(!0), r._announcer.announceDrag(i, e));
        }
      }, this.handleDrop = function (e) {
        if (g(e, l)) {
          var t = String(r.monitor.getSourceId()),
            n = r.sourceNodes.get(t);
          r._announcer.announceDrop(null != n ? n : null, t), r.actions.drop(), r.endDrag(e);
        }
      }, this.manager = e, this.actions = e.getActions(), this.monitor = e.getMonitor(), this.context = t, this.options = n, this._isDragTrigger = null != (i = null == n ? void 0 : n.isDragTrigger) ? i : d, this.sourceNodes = new Map(), this.sourcePreviewNodes = new Map(), this.sourcePreviewNodeOptions = new Map(), this.targetNodes = new Map(), this._previewer = new s(t.document, n), this._announcer = new o(t.document, n);
    }
    var t = e.prototype;
    return t.setup = function () {
      var t;
      if (e.isSetUp) throw new Error('Cannot have two Keyboard backends at the same time.');
      e.isSetUp = !0, this._handlingFirstEvent = !0, null == (t = this.context.window) || t.addEventListener('keydown', this.handleGlobalKeyDown, {
        capture: !0
      }), this._previewer.attach(), this._announcer.attach();
    }, t.teardown = function () {
      var t;
      e.isSetUp = !1, null == (t = this.context.window) || t.removeEventListener('keydown', this.handleGlobalKeyDown, {
        capture: !0
      }), this.endDrag(), this._previewer.detach(), this._announcer.detach();
    }, t.setDndMode = function (e) {
      var t;
      null == (t = this.options) || null == t.onDndModeChanged || t.onDndModeChanged(e);
    }, t.profile = function () {
      return {
        sourcePreviewNodes: this.sourcePreviewNodes.size,
        sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
        sourceNodes: this.sourceNodes.size
      };
    }, t.connectDragSource = function (e, t) {
      var n = this,
        i = this.handleDragStart.bind(this, e);
      return this.sourceNodes.set(e, t), t.addEventListener('keydown', i), function () {
        n.sourceNodes.delete(e), t.removeEventListener('keydown', i);
      };
    }, t.connectDragPreview = function (e, t, n) {
      var i = this;
      return this.sourcePreviewNodeOptions.set(e, n), this.sourcePreviewNodes.set(e, t), function () {
        i.sourcePreviewNodes.delete(e), i.sourcePreviewNodeOptions.delete(e);
      };
    }, t.connectDropTarget = function (e, t) {
      var n = this;
      return this.targetNodes.set(e, t), t.addEventListener('keydown', this.handleDrop), t.tabIndex = Math.max(-1, t.tabIndex), function () {
        n.targetNodes.delete(e), t.removeEventListener('keydown', n.handleDrop);
      };
    }, t.endDrag = function (e) {
      var t;
      null != e && u(e), null == (t = this._navigator) || t.disconnect(), this._previewer.clear(), this.monitor.isDragging() && this.actions.endDrag(), this.setDndMode(!1);
    }, e;
  }();
  v.isSetUp = void 0, e.KeyboardBackend = v, e.default = function (e, t, n) {
    return new v(e, t, n);
  }, e.isKeyboardDragTrigger = d;
});